import { useTranslation } from 'react-i18next';

/**
 * Fixed banner that surfaces a disconnected WebSocket. Shows the retry
 * attempt once the first reconnect cycle has passed, so users can tell
 * the app is actively trying (rather than frozen).
 *
 * Props:
 *   attempt  — current retry attempt number (0 before any retries).
 */
export default function ReconnectingBanner({ attempt = 0 }) {
  const { t } = useTranslation();
  const label = attempt > 1
    ? t('reconnecting.bannerAttempt', { attempt })
    : t('reconnecting.banner');
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        backgroundColor: '#F59E0B',
        color: '#1C1917',
        textAlign: 'center',
        padding: '8px 16px',
        fontSize: '0.875rem',
        fontWeight: 600,
        zIndex: 100,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: '0.5rem',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 10, height: 10, borderRadius: '50%',
          background: '#1C1917',
          animation: 'vq-reconnect-pulse 1.1s ease-in-out infinite',
        }}
      />
      <span>{label}</span>
      <style>{`
        @keyframes vq-reconnect-pulse {
          0%, 100% { opacity: 0.3; transform: scale(0.85); }
          50%      { opacity: 1;   transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}
